(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonials"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('goom-style-reviews')){
customElements.define('goom-style-reviews',class extends HTMLElement{
connectedCallback(){
this.abort=new AbortController();const opts={signal:this.abort.signal};
this.track=this.querySelector('.gr-track');this.cards=[...this.querySelectorAll('.gr-card')];this.clips=this.cards.filter(card=>card.dataset.src);this.dialog=this.querySelector('dialog');this.player=this.querySelector('.gr-player');this.prev=this.querySelector('.gr-prev');this.next=this.querySelector('.gr-next');
this.cards.forEach(card=>card.addEventListener('click',()=>this.open(card),opts));
this.prev.addEventListener('click',()=>this.scroll(1),opts);this.next.addEventListener('click',()=>this.scroll(-1),opts);this.track.addEventListener('scroll',()=>this.update(),opts);
this.querySelector('.gr-close').addEventListener('click',()=>this.dialog.close(),opts);this.dialog.addEventListener('click',event=>{if(event.target===this.dialog)this.dialog.close()},opts);this.dialog.addEventListener('close',()=>this.stop(),opts);
this.querySelector('.gr-modal-prev').addEventListener('click',()=>this.change(-1),opts);this.querySelector('.gr-modal-next').addEventListener('click',()=>this.change(1),opts);
this.dialog.addEventListener('keydown',event=>{if(event.target===this.player)return;if(event.key==='ArrowDown'){event.preventDefault();this.change(1)}if(event.key==='ArrowUp'){event.preventDefault();this.change(-1)}},opts);
this.player.addEventListener('ended',()=>{if(this.index<this.clips.length-1)this.change(1)},opts);
this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);
this.observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{const video=entry.target;if(entry.isIntersecting&&!this.dialog.open&&!matchMedia('(prefers-reduced-motion: reduce)').matches){if(!video.src)video.src=video.dataset.src;video.play().then(()=>video.classList.add('is-playing')).catch(()=>{});}else{video.pause();video.classList.remove('is-playing')}});},{threshold:.6});this.querySelectorAll('.gr-preview').forEach(video=>this.observer.observe(video));this.update();
}
scroll(direction){this.track.scrollBy({left:direction*250,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})}
update(){const distance=Math.abs(this.track.scrollLeft),max=this.track.scrollWidth-this.track.clientWidth;this.prev.hidden=distance<2;this.next.hidden=max-distance<2;}
open(card){this.index=this.clips.indexOf(card);if(this.index<0)return;this.querySelectorAll('.gr-preview').forEach(video=>video.pause());this.lastFocus=card;this.oldOverflow=document.documentElement.style.overflow;this.dialog.showModal();document.documentElement.style.overflow='hidden';this.load();}
load(){const card=this.clips[this.index];this.player.pause();this.player.src=card.dataset.src;this.player.poster=card.querySelector('img')?.src||'';this.querySelector('.gr-player-name').textContent=card.dataset.name;this.player.setAttribute('aria-label',card.dataset.name);this.querySelector('.gr-modal-prev').hidden=this.index===0;this.querySelector('.gr-modal-next').hidden=this.index===this.clips.length-1;this.player.play().catch(()=>{});}
change(delta){const next=this.index+delta;if(next<0||next>=this.clips.length)return;this.index=next;this.load()}
stop(){this.player.pause();this.player.removeAttribute('src');this.player.load();document.documentElement.style.overflow=this.oldOverflow||'';this.lastFocus?.focus()}
disconnectedCallback(){if(this.dialog?.open){this.dialog.close();this.stop()}this.abort?.abort();this.resize?.disconnect();this.observer?.disconnect()}
});}

  } catch(e) { console.error(e); }
})();
})();
